module.exports = __webpack_public_path__ + "img/Crew-1.d4abeb9b.png";